import * as React from 'react'
import {Box} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";


export default function discountColumn() {
    return {
        name: 'discount', label: 'Discount',
        options: {
            customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                {formatPercentage(value, { decimals: 0 })}
            </Box>
        }
    }
}